import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import MuiTableRow from "@mui/material/TableRow";
import MuiTableCell from "@mui/material/TableCell";
import { Fragment } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TableSortLabel from "@mui/material/TableSortLabel";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import visuallyHidden from "../node_modules/@mui/utils/esm/visuallyHidden/visuallyHidden.js";
const TableHeader = t0 => {
  const $ = c(11);
  const {
    columns,
    data,
    order,
    orderBy,
    onRequestSort
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== onRequestSort) {
    t1 = property => event => {
      onRequestSort(event, property);
    };
    $[0] = onRequestSort;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const createSortHandler = t1;
  let spannedCols;
  if ($[2] !== columns || $[3] !== data) {
    spannedCols = [];
    for (const header of columns) {
      const {
        type,
        title,
        colspan,
        comparison
      } = header;
      if (colspan && spannedCols.length > 0) {
        const prevCol = spannedCols[spannedCols.length - 1];
        if (prevCol) {
          prevCol.colspan = true;
          continue;
        }
      }
      const key = header.value.key;
      const columnDataIndex = data?.findIndex(column => column.key === header.value.key);
      if (columnDataIndex === -1) {
        continue;
      }
      const columnData = data[columnDataIndex];
      if (!columnData) {
        continue;
      }
      const columnType = columnData.type;
      const numeric = columnType !== "string" && columnType !== "boolean" && columnType !== "icon" || comparison !== void 0;
      spannedCols.push({
        key,
        type,
        title,
        colspan: false,
        numeric,
        orderKey: comparison?.key || key,
        sortable: header.sortable ?? true
      });
    }
    $[2] = columns;
    $[3] = data;
    $[4] = spannedCols;
  } else {
    spannedCols = $[4];
  }
  const spannedColumns = spannedCols;
  let t2;
  if ($[5] !== createSortHandler || $[6] !== order || $[7] !== orderBy || $[8] !== spannedColumns || $[9] !== theme) {
    t2 = /* @__PURE__ */jsx(MuiTableRow, {
      children: spannedColumns.map((t3, idx) => {
        const {
          title: title_0,
          key: key_0,
          type: type_0,
          numeric: numeric_0,
          orderKey,
          sortable
        } = t3;
        return /* @__PURE__ */jsxs(Fragment, {
          children: [/* @__PURE__ */jsx(MuiTableCell, {
            className: type_0,
            variant: "head",
            align: numeric_0 ? "right" : "left",
            sx: {
              whiteSpace: "nowrap",
              border: "none",
              boxShadow: "none",
              position: "sticky",
              top: 0
            },
            children: /* @__PURE__ */jsxs(TableSortLabel, {
              active: orderBy === orderKey,
              direction: orderBy === orderKey ? order : "desc",
              onClick: createSortHandler(orderKey),
              disabled: !sortable,
              IconComponent: ArrowDropDownIcon,
              sx: {
                height: theme.sizes.spacing["07"]
              },
              children: [title_0 || "", orderBy === orderKey ? /* @__PURE__ */jsx(Box, {
                component: "span",
                sx: visuallyHidden,
                children: order === "desc" ? "sorted descending" : "sorted ascending"
              }) : null]
            })
          }, `th-${key_0 || type_0}-${idx}`), spannedColumns[idx]?.colspan && /* @__PURE__ */jsx(MuiTableCell, {
            className: type_0,
            variant: "head",
            sx: {
              whiteSpace: "nowrap",
              border: "none",
              boxShadow: "none",
              position: "sticky",
              top: 0
            }
          }, `th-spanned-${idx}`)]
        }, `fragment-${key_0}-${idx}`);
      })
    });
    $[5] = createSortHandler;
    $[6] = order;
    $[7] = orderBy;
    $[8] = spannedColumns;
    $[9] = theme;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export { TableHeader as default };